<template>
  <el-container>
    <el-header height="82px">
      <img src="./img/Frame.png" alt="" class="logo_img" />
      <!-- <img src="./img/user.jpeg" alt="" class="user_img" /> -->
      <UserHeader></UserHeader>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background: #fff">
        <el-button type="goon" style="margin: 24px 0; width: 100px" @click="goIndex"
          >返回首页</el-button
        >
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="activeIndex"
          @select="activeChange"
          text-color="#131414"
          active-text-color="#2AB18B"
          :router="true"
        >
          <el-menu-item
            index="/manage_center/course_management"
            :class="
              activeIndex == '/manage_center/course_management'
                ? 'border-green'
                : ''
            "
          >
            <img
              src="./img/zzk_open.png"
              alt=""
              class="aside_img"
              v-show="activeIndex == '/manage_center/course_management'"
            />
            <img
              src="./img/zzk_on.png"
              alt=""
              class="aside_img"
              v-show="activeIndex != '/manage_center/course_management'"
            />
            <span slot="title">课程管理</span>
          </el-menu-item>
          <el-menu-item
            index="/manage_center/study_records"
            :class="
              activeIndex == '/manage_center/study_records'
                ? 'border-green'
                : ''
            "
          >
            <img
              src="./img/xtbb_open.png"
              alt=""
              class="aside_img"
              v-if="activeIndex == '/manage_center/study_records'"
            />
            <img
              src="./img/xtbb_on.png"
              alt=""
              class="aside_img"
              v-show="activeIndex != '/manage_center/study_records'"
            />
            <span slot="title">学习记录</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import UserHeader from '@/components/user-header'
export default {
    components: {
    UserHeader
  },
  data() {
    return {
      activeIndex: "/manage_center/course_management",
    };
  },
  methods: {
    activeChange(index) {
      this.activeIndex = index;
    },
    goIndex(){
      this.$router.push("/count_center/list")
    }
  },
  mounted() {
    this.activeIndex = this.$route.path
  },
};
</script>

<style lang="less" scoped>
.el-header {
  padding: 0 32px;
  background: #201f1f;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-container {
  width: 100%;
  min-height: 100%;
}
.logo_img {
  height: 20px;
  width: 82px;
}
.user_img {
  width: 42px;
  height: 42px;
}
.el-button--goon,
.el-button--goon:focus,
.el-button--goon.is-active,
.el-button--goon:active {
  background: #2ab18b;
  border-color: #2ab18b;
  color: #fff;
}
.el-button--goon:hover {
  background: #8cd8da;
  border-color: #8cd8da;
  color: #fff;
}
.el-aside {
  text-align: center;
}
.aside_img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.el-menu {
  border-right-width: 0;
}
/deep/.el-menu-item.is-active {
  color: #2ab18b;
}
/deep/.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: #f7fffd;
}
.border-green {
  border-right: 2px solid #2ab18b;
}
</style>